import { FC } from "react";
import {
  Box,
  Heading,
  Text,
  Container,
  Flex,
  Theme,
  Button,
} from "@radix-ui/themes";
import { themeMap, themeRadiusMap } from "@/utils/constants/Themes";
import { useNavigate } from "react-router-dom";
import { ExternalLinkIcon } from "@radix-ui/react-icons";

interface CarouselContentProps {
  activeSlide: any;
}

export const CarouselContent: FC<CarouselContentProps> = ({ activeSlide }) => {
  const navigate = useNavigate();
  const theme = themeMap[activeSlide?.theme.toUpperCase()] || "violet";
  const radius = themeRadiusMap[activeSlide?.theme.toUpperCase()] || "none";

  const themeClass = `theme-${activeSlide.theme.toLowerCase()}`;

  return (
    <Flex className="cover-carousel__content" align="center">
      <Container px={{ initial: "4", md: "2", xl: "0" }} flexShrink="1">
        <Box width={{ initial: "100%", lg: "50%" }} maxWidth="100%">
          <Flex direction="column" gap="3" wrap="wrap">
            {/* Logo */}
            <Box>
              <img
                src={activeSlide.logoURL}
                alt={activeSlide.alt}
                width={150}
                style={{
                  width: "150px",
                  height: "auto",
                }}
              />
            </Box>
            <Box>
              <Heading as="h1" size="7" my="0">
                {activeSlide.heading}
              </Heading>
              <Text as="p" size="5" weight="light">
                {activeSlide.desc}
              </Text>
            </Box>
            <Box pt="2" className={themeClass}>
              <Theme
                appearance="dark"
                accentColor={theme}
                radius={radius}
                style={{ backgroundColor: "transparent" }}
              >
                <Flex direction={{ initial: "column", md: "row" }} gap="3">
                  {activeSlide.links.map((link: any, index: number) => {
                    const isExternal = link.url.includes("http");

                    if (isExternal) {
                      return (
                        <Button
                          size="3"
                          variant={index === 0 ? "solid" : "soft"}
                          key={index}
                          onClick={() => window.open(link.url, "_blank")}
                        >
                          {link.text} <ExternalLinkIcon />
                        </Button>
                      );
                    }

                    return (
                      <Button
                        size="3"
                        variant={index === 0 ? "solid" : "soft"}
                        key={index}
                        onClick={() => navigate(link.url)}
                      >
                        {link.text}
                      </Button>
                    );
                  })}
                </Flex>
              </Theme>
            </Box>
          </Flex>
        </Box>
      </Container>
    </Flex>
  );
};
